import type { WidgetId } from '@wix/members-area-app-definitions';
import type { ComponentRef, FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { MenuId } from '../../../constants';
import { getMenu } from '../../../editor/editor-sdk-wrappers';
import { removeMenuItemsByWidgetIds, updateMenuItemLabel } from './menu';

const SETTINGS_SUB_MENU_INNER_ELEMENTS_PATH = ['horizontalMenu', 'navbar'];

export const removeSettingsPageSubMenuItems = async (
  editorSDK: FlowEditorSDK,
  widgetsIds: WidgetId[],
) => {
  return removeMenuItemsByWidgetIds(
    editorSDK,
    MenuId.SettingsSubMenu,
    widgetsIds,
  );
};

export const getSettingsPageSubMenu = async (editorSDK: FlowEditorSDK) => {
  return getMenu(editorSDK, MenuId.SettingsSubMenu);
};

export const updateSettingsPageSubMenuItemLabel = async (
  editorSDK: FlowEditorSDK,
  widgetId: WidgetId,
  newLabel: string,
) => {
  return updateMenuItemLabel({
    editorSDK,
    menuId: MenuId.SettingsSubMenu,
    widgetId,
    newLabel,
  });
};

export const connectMemberSettingsSubMenuToInnerElements = async (
  editorSDK: FlowEditorSDK,
  menuCompRef: ComponentRef,
) => {
  await editorSDK.menu.connectToInnerElement('', {
    menuCompRef,
    menuId: MenuId.SettingsSubMenu,
    innerElementsPath: SETTINGS_SUB_MENU_INNER_ELEMENTS_PATH,
  });
};
